<template>
    <ion-page>  
        <ion-content :force-overscroll="!isWeb">
            <ModalMessage
                v-if="layout"
                :icon=icon
                :title="layout.labels.title"
                :button="{textContent: layout.labels.button, danger: false}"
                :description="layout.labels.lines"
                @button-click="routeAway()"
                :show-arrow="false"
            />
      </ion-content>
    </ion-page>
</template>


<script setup lang="ts">
import { ref, onBeforeMount, onUnmounted, toRefs } from 'vue'
import { IonContent, IonPage } from "@ionic/vue";
import { useRoute, useRouter } from 'vue-router';
import ModalMessage from '@/globals/components/ModalMessage.vue';
import router from '@/router';
import { getComputedPageLayout, getIcon, IPageLayout } from '@/helpers/api';
import { useModalManager } from '@/modules/a.worksheets/services/modalManager';
import { useDeviceStatus } from '@/stores/deviceStatus';


interface _1615B extends IPageLayout {
    labels: {
        title: string,
        lines: Array<string>
        button: string
    }
    icons: {icon: string}
    commands: {
        router: string
    }
}

const { isWeb } = toRefs(useDeviceStatus());

const icon = ref<string>()
const layout = getComputedPageLayout<_1615B>('1615B')
onBeforeMount(async () => {
    icon.value = await getIcon('1615B', 'icon')
})

const modalManager = useModalManager()
function routeAway(){
    if(layout.value){
        router.push(layout.value.commands.router)
        modalManager.close('btn click')
    }
}

</script>

<style scoped>
ion-content::part(background){
    background-color: transparent;
}
</style>

<style>
#worksheet-ion-page.ion-page-hidden.ion-page[aria-hidden="true"]{
    display: block !important;
}
</style>